












import { defineComponent, ref } from '@vue/composition-api';
import { Field } from '@/store/types';
import FieldEditForm from './FieldEditForm.vue';

export default defineComponent({
	components: {
		FieldEditForm,
	},
	props: {
		field: {
			type: Object as () => Field,
			required: true,
		},
	},
	setup() {
		const showEditDialog = ref<boolean>(false);

		return {
			showEditDialog,
		};
	},
});
